import { EMPTY_VALUE, formatInteger } from '@/lib/format'
import { formatTon, issueCodes, type ReconcileRecord } from '@/lib/kantar-dia'
import { messages } from '@/lib/messages'

const t = messages.reconcile

/**
 * Tartı no; kantar kaydı olmayan DİA satırında (H-B) kaynakta boş olabilir, tip `number`
 * dese de "null" yazmasın.
 */
export const tartiNoText = (value: number | null | undefined) =>
  value === null || value === undefined ? EMPTY_VALUE : String(value)

export const orUnknown = (value: string | null | undefined) =>
  value === null || value === undefined || value === '' ? t.unknown : value

/** Sayı kolonunda boş değer "—": uzun "bilinmiyor" sağa hizalı sütunda okunmayı bozuyordu. */
export const ton = (value: number | null) =>
  value === null ? EMPTY_VALUE : formatTon(value * 1000)

// Eksi için tipografik "−" (U+2212): açıklama metinlerindeki "DİA − Kantar" ile aynı.
const sign = (value: number) => (value > 0 ? '+' : value < 0 ? '−' : '')
export const signedKg = (kg: number) => `${sign(kg)}${formatInteger(Math.abs(kg))}`
export const signedTon = (kg: number) => `${sign(kg)}${formatTon(Math.abs(kg))}`

/**
 * Excel için hata kodları adlarıyla ve varsa notlarıyla: "H-A İrsaliye kesilmemiş (DİA
 * aktarım hatası: …); U-H Şoför / nakliyeci farkı (Şoför, Nakliyeci)". Yalnız kod ("H-A")
 * dosyada ne olduğunu anlatmıyordu.
 */
export function issueCodesText(record: ReconcileRecord): string {
  return issueCodes(record)
    .map((code) => {
      const notes = [
        ...new Set(
          record.issues.filter((issue) => issue.code === code && issue.note).map((i) => i.note!),
        ),
      ]
      const name = `${code} ${t.codes[code]}`
      return notes.length > 0 ? `${name} (${notes.join(', ')})` : name
    })
    .join('; ')
}
